import { Infoicon, SearchBar, Sprite } from '@ktag/styleguide/dist/react';
import { JobResult } from 'jobs.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ARBEITSORT_ATTRIBUTE_ID, ABTEILUNG_ATTRIBUTE_ID } from '../../constants';

interface Props {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  jobs: JobResult[];
}

const AdminViewJobSearch = ({ searchTerm, setSearchTerm, jobs }: Props) => {
  const { t } = useTranslation('jobs');

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const filteredJobs = jobs?.filter((job) =>
    job?.title?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <>
      <SearchBar
        search={searchTerm}
        setSearch={setSearchTerm}
        placeholder={t('adminview_search_placeholder')}
        small
      />
      {filteredJobs?.length > 0 ? (
        <table className="adminview__table adminview__table--jobs">
          <thead>
            <tr>
              <th>ID</th>
              <th>Titel</th>
            </tr>
          </thead>
          <tbody>
            {filteredJobs.map((job) => (
              <tr key={job.id}>
                <td className="adminview__cell-id">
                  <span>{job.id}</span>
                  <Sprite
                    id="copy"
                    onClick={() => copyToClipboard(job.id)}
                    additionalClassNames="adminview__copy-icon"
                  />
                </td>
                <td className="adminview__cell-title">
                  {job.title}
                  <Infoicon
                    text={`${job.attributes[ARBEITSORT_ATTRIBUTE_ID]} - ${job.attributes[ABTEILUNG_ATTRIBUTE_ID]}`}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="adminview__no-jobs">{t('adminview_no_jobs')}</div>
      )}
    </>
  );
};

export default AdminViewJobSearch;
